import { useEffect } from 'react';
import { auth, db } from '../firebase';
import Badge from '@mui/material/Badge';
import { Notifications as NotificationsIcon } from '../icons';
import { useLocation } from 'react-router-dom';

// Marcar todas las notificaciones no leídas del usuario como leídas
const markAllNotificationsAsRead = () => {
  const user = auth.currentUser;
  if (!user) return;

  db.collection('notifications')
    .where('userId', '==', user.uid)
    .where('read', '==', false)
    .get()
    .then((snapshot) => {
      snapshot.docs.forEach((doc) => {
        doc.ref.update({ read: true }).catch((err) => {
          console.error('Error marking notification as read:', err);
        });
      });
    });
};

// Suscripción en tiempo real a notificaciones no leídas
export const subscribeToNotifications = (callback) => {
  const user = auth.currentUser;
  if (!user) return null;

  return db
    .collection('notifications')
    .where('userId', '==', user.uid)
    .where('read', '==', false)
    .onSnapshot((snapshot) => {
      callback(snapshot.size > 0);
    });
};

// Componente NotificationIcon
const NotificationIcon = ({ hasNewNotifications }) => {
  const location = useLocation(); // Obtener la ubicación actual
  const currentPage = location.pathname; // Obtener la página actual

  useEffect(() => {
    if (currentPage === '/notifications') {
      markAllNotificationsAsRead();
    }
  }, [currentPage]);

  return (
    <Badge color="error" variant="dot" invisible={!hasNewNotifications}>
      <NotificationsIcon />
    </Badge>
  );
};

export default NotificationIcon;
